export enum SidenavState {
  Auto,
  Closed,
  Collapsed,
  Expanded,
}
